export type PageHelpKey = 'issues' | 'new-issue' | 'detail';

export interface HelpStep {
  title: string;
  body: string;
}

export interface HelpContent {
  title: string;
  intro: string;
  steps: HelpStep[];
}

export const helpContent: Record<'tr' | 'en', Record<PageHelpKey, HelpContent>> = {
  tr: {
    issues: {
      title: 'Destek Talepleri',
      intro: 'Bu sayfada tüm destek taleplerinizi görüntüler ve yönetirsiniz.',
      steps: [
        {
          title: 'Taleplerinizi görün',
          body: 'Oluşturduğunuz tüm talepler durum ve öncelik etiketleriyle burada listelenir.',
        },
        {
          title: 'Filtreleyin ve arayın',
          body: 'Durum ile tipe göre filtreleyebilir, başlık veya açıklamada arama yapabilirsiniz.',
        },
        {
          title: 'Yeni talep oluşturun',
          body: '“Yeni Talep” butonuyla yeni bir destek kaydı açabilirsiniz.',
        },
      ],
    },
    'new-issue': {
      title: 'Yeni Talep Oluştur',
      intro: 'Talebinizi olabildiğince net anlatın; doğru bilgi çözüm süresini kısaltır.',
      steps: [
        {
          title: 'Proje seçimi zorunlu',
          body: 'Talebin hangi projeye ait olduğunu seçmeden gönderemezsiniz; seçilen proje formdaki alanları belirler.',
        },
        {
          title: 'Başlık ve açıklama',
          body: 'Kısa bir başlık ve en az 150 karakterlik bir açıklama girin. Tip ve önceliği belirleyin.',
        },
        {
          title: 'Alanlar ve görseller',
          body: 'Projeye özel alanları doldurun ve gerekiyorsa konuyu anlatan görseller yükleyin.',
        },
      ],
    },
    detail: {
      title: 'Talep Detayı',
      intro: 'Talebinizin tüm ayrıntılarını ve yazışma geçmişini buradan takip edersiniz.',
      steps: [
        {
          title: 'Detaylar ve görseller',
          body: 'Talebin tüm alanlarını ve yüklenen görselleri galeride inceleyebilirsiniz.',
        },
        {
          title: 'Yanıt geçmişi',
          body: 'Ekip ile aranızdaki tüm yazışmalar kronolojik olarak görüntülenir.',
        },
        {
          title: 'Yanıt ekleyin',
          body: 'Talep açıkken yeni yorum yazabilirsiniz. Kapatılmış veya reddedilmiş taleplere yanıt verilemez.',
        },
      ],
    },
  },
  en: {
    issues: {
      title: 'Support Requests',
      intro: 'On this page, you view and manage all your support requests.',
      steps: [
        {
          title: 'View your requests',
          body: 'All requests you created are listed here with status and priority badges.',
        },
        {
          title: 'Filter and search',
          body: 'You can filter by status and type, and search by title or description.',
        },
        {
          title: 'Create new request',
          body: 'You can open a new support request using the "New Request" button.',
        },
      ],
    },
    'new-issue': {
      title: 'Create New Request',
      intro: 'Please describe your request as clearly as possible; accurate information shortens resolution time.',
      steps: [
        {
          title: 'Project selection is required',
          body: 'You cannot submit without selecting which project the request belongs to; the selected project determines the form fields.',
        },
        {
          title: 'Title and description',
          body: 'Enter a short title and a description of at least 150 characters. Specify the type and priority.',
        },
        {
          title: 'Fields and images',
          body: 'Fill in the project-specific fields and upload images explaining the issue if necessary.',
        },
      ],
    },
    detail: {
      title: 'Request Details',
      intro: 'From here, you can track all the details and conversation history of your request.',
      steps: [
        {
          title: 'Details and images',
          body: 'You can examine all fields of the request and uploaded images in the gallery.',
        },
        {
          title: 'Reply history',
          body: 'All correspondence between you and the team is displayed chronologically.',
        },
        {
          title: 'Add a reply',
          body: 'You can write new comments while the request is open. Closed or rejected requests cannot be replied to.',
        },
      ],
    },
  },
};
